import React from "react";

//for loading animation
import "react-placeholder/lib/reactPlaceholder.css";
import ReactPlaceholder from "react-placeholder";

//styling
import "./clusterRow.css";
const ClusterRowMobileInfoPlaceholder = () => {
  return (
    <ReactPlaceholder
      className="__clusterRowMobileInfo"
      type="rect"
      showLoadingAnimation
      style={{ width: "300px", height: "320px", margin: "0 auto" }}
    ></ReactPlaceholder>
  );
};

export default ClusterRowMobileInfoPlaceholder;
